// extracted by mini-css-extract-plugin
export var copyright_container = "copyright_container-7xC";
export var do_not_track = "do_not_track-h2n";
export var footer = "footer-TDM";
export var footer_container = "footer_container-IA1";
export var footer_ctas = "footer_ctas-HdD";
export var logo = "logo-te5";
export var logo_with_legal_copy = "logo_with_legal_copy-WSK";
export var menus_container = "menus_container-31C";
export var social_copyright_container = "social_copyright_container-BWX";